/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs */

const en__field__enum_studyprograms_study_islamic_studies20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamic Studies`)
};

const de__field__enum_studyprograms_study_islamic_studies20 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Islamische Studien`)
};

/**
* | output |
* | --- |
* | "Islamic Studies" |
*
* @param {_Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_islamic_studies20 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Islamic_Studies20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_islamic_studies20(inputs)
	return de__field__enum_studyprograms_study_islamic_studies20(inputs)
});
export { _field__enum_studyprograms_study_islamic_studies20 as "_field__enum_studyPrograms_STUDY_ISLAMIC_STUDIES" }